{
  "main": "Principale",
  "my_library": "Ma bibliothèque",
  "node_names": {
    "Folder": "Dossier",
    "PersonalMappingLibrary": "Mon espace de travail",
    "MappingLibrary": "Espace de travail d'équipe",
    "Map": "Planifier",
    "Layer": "Couche",
    "MapObject": "Objet",
    "Schedule": "Calendrier",
    "ScheduleVersion": "Calendrier"
  },
  "static_library_names": {
    "recently_viewed": "Consulté récemment",
    "favourites": "Favoris"
  },
  "static_library_empty": {
    "recently_viewed": "Les plans que vous avez récemment ouverts s'afficheront ici",
    "favourites": "Les plans et dossiers que vous aimez s'afficheront ici pour que vous puissiez y accéder facilement"
  },
  "static_library_empty_button": {
    "recently_viewed": "Commencez avec votre premier plan",
    "favourites": "Consultez les plans de projet"
  },
  "node_content": {
    "last_activity": "Dernière activité {{ latestActivityDate }}",
    "created": "Créé {{ createdAt }}",
    "last_viewed": "Consulté pour la dernière fois {{ viewedAt }}"
  },
  "create_node": {
    "saveInFolder": "Enregistrer dans un dossier",
    "title": "Créez {{ nodeName }}",
    "fieldLabel": "{{ nodeName }} nom",
    "creating": "Création de {{ nodeName }}",
    "maxInputChars": "Le nom ne doit pas comporter plus de 500 caractères"
  },
  "permissions": "Modifier les autorisations de {{ nodeName }}",
  "update_node": {
    "title": "Renommer {{ nodeName }}",
    "description": "Ce {{ nodeName }} sera mis à jour pour tout le monde.",
    "updating": "Renommer {{ nodeName }}"
  },
  "delete_node": {
    "singular_title": "Supprimer un {{ nodeType }}",
    "singular_description": "La suppression de ce {{ nodeType }} supprimera également tout le contenu.",
    "singular_confirm_button": "Supprimer {{ nodeType }}",
    "multi_title": "Supprimer {{ count }} articles",
    "multi_description": "La suppression de ces éléments supprimera également tout le contenu.",
    "multi_confirm_button": "Supprimer des éléments"
  },
  "overflow": {
    "description": "Cliquez pour ouvrir les options pour {{ nodeName }}",
    "rename": "Renommer {{ nodeName }}",
    "delete": "Supprimer {{ nodeName }}",
    "permissions": "Modifier les autorisations de {{ nodeName }}"
  },
  "empty_node": "{{ nodeName }} est vide",
  "folder_browser_view": {
    "while_in": {
      "list": "Afficher sous forme de vignettes",
      "tile": "Afficher sous forme de liste"
    }
  },
  "sort": {
    "folder_first_asc": "Dossier en premier (A à Z)",
    "name_asc": "Nom (A à Z)"
  },
  "saveLocation": {
    "visibleYou": "Visible uniquement pour vous",
    "visibleOtherTeamMembers": "Visible pour les autres membres de l'équipe",
    "visibleWholeProject": "Visible pour tous",
    "teamMembers": "membres de l'équipe"
  },
  "hints": {
    "PersonalMappingLibrary": {
      "title": "Mon espace de travail",
      "first_paragraph": "Les plans que vous créez ici ne seront disponibles que pour vous. \nUtilisez le bouton « Créer un plan » pour créer votre premier plan.",
      "second_paragraph": "Lorsque vous êtes prêt à partager des plans avec votre équipe, vous pouvez utiliser « l'espace de travail d'équipe »."
    },
    "MappingLibrary": {
      "title": "Espace de travail d'équipe",
      "first_paragraph": "Les plans créés ici sont partagés au sein de votre équipe. Utilisez cet espace lorsque vous collaborez avec d'autres membres de l'équipe.",
      "second_paragraph": "Vous pouvez également organiser vos plans dans des dossiers, par exemple pour différents départements."
    },
    "Map": {
      "title": "Aucune couche n'a encore été ajoutée",
      "first_paragraph": "Commencez par créer une couche pour ajouter des objets à votre plan."
    },
    "Folder": {
      "title": "Le dossier est vide",
      "first_paragraph": "Utilisez le bouton « Créer un plan » ci-dessus pour ajouter un plan ici."
    },
    "ScheduleVersion": {
      "title": "{{ type }}",
      "first_paragraph": "Créez un {{ type }} pour commencer à planifier des événements."
    }
  },
  "hints_static_libraries": {
    "recently_viewed": {
      "title": "Consulté récemment",
      "first_paragraph": "Les plans que vous avez récemment consultés apparaîtront ici."
    },
    "favourites": {
      "title": "Favoris",
      "first_paragraph": "Vos plans et dossiers préférés apparaîtront ici."
    }
  },
  "remove_node": {
    "singular_title": "Supprimer un {{ nodeType }}",
    "singular_description": "La suppression de ce {{ nodeType }} le supprimera du plan, mais existera toujours dans son plan d'origine",
    "singular_confirm_button": "Supprimer {{ nodeType }}",
    "multi_title": "Supprimer {{ count }} articles",
    "multi_description": "La suppression de ces éléments supprimera également tout le contenu.\n \nLes couches importées/liées seront supprimées du plan, mais existeront toujours dans son plan d'origine.",
    "multi_confirm_button": "Supprimer des éléments"
  },
  "cannot_drop_folder_into_its_sub_folder": "Impossible de déposer un dossier dans son propre sous-dossier",
  "drag_and_drop": {
    "moving_multiple_items": "Déplacer {{ count }} objets..."
  },
  "create_map_location": "Enregistrer dans un dossier"
}